import React, { useEffect, useState } from 'react';
import { useTranslation } from '../i18n/LocaleContext';

// Platform pulse strip — the three vanity numbers task apps surface near the
// bottom of the feed. Numbers drift slowly so the page feels alive, not frozen.
const nf = new Intl.NumberFormat('en-US');

const StatsStrip = () => {
  const { t } = useTranslation();
  const [stats, setStats] = useState({ tasks: 12480, online: 1163, paid: 8342 });

  useEffect(() => {
    const timer = setInterval(() => {
      setStats((s) => ({
        tasks: s.tasks + Math.floor(Math.random() * 7),
        online: Math.max(900, s.online + Math.floor(Math.random() * 21) - 10),
        paid: s.paid + Math.round(Math.random() * 40) / 10,
      }));
    }, 6000);
    return () => clearInterval(timer);
  }, []);

  const cells = [
    [nf.format(stats.tasks), t('statsTasksToday')],
    [nf.format(stats.online), t('statsOnline')],
    [`$${nf.format(Math.round(stats.paid))}`, t('statsPaid')],
  ];

  return (
    <div className="max-w-md mx-auto bg-white border-y border-black/[0.05] grid grid-cols-3">
      {cells.map(([value, label]) => (
        <div key={label} className="py-3 text-center">
          <p className="tabular text-[15px] font-extrabold text-ink">{value}</p>
          <p className="mt-0.5 text-[11px] text-ink-muted">{label}</p>
        </div>
      ))}
    </div>
  );
};

export default StatsStrip;
